import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import AdListTable from './AdListTable/AdListTable';
import {
  type AdListTableReorderCallback,
  type AdListTableRowCallback,
  type AdListTableRowCheckCallback,
} from './AdListTable/types';
import AdListToolbar from './AdListToolbar/AdListToolbar';

const DEFAULT_WORK_MESSAGE = 'Working…';

const Container = styled.div`
  background-color: white;
  border-right: 1px solid rgb(242, 235, 235);
  display: grid;
  grid-template-rows: 50px 1fr;
  height: 100%;
`;

const WorkMessage = styled.div`
  position: absolute;
  top: 85px;
  left: 90px;
  background: white;
  height: 60px;
  width: 300px;
  z-index: 999;
  border-radius: 4px;
  padding: 20px 0px 20px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 6px 16px rgb(0 0 0 / 10%);
`;

function AdList() {
  const store_creative = store.creative;
  if (!store_creative) return null;

  const { currentWorkMessage, isWorking } = store_creative.ads;

  const onAdClick: AdListTableRowCallback = ({ ad }) => {
    // Formerly located in AdListTable.handleView
    const adManager = store_creative.ads;
    if (ad === adManager.current) return;
    adManager.current?.setViewingComments(false);
    ad.navigateTo();
    ad.reload();
  };

  const onAdCheck: AdListTableRowCheckCallback = ({ ad, shiftKey }) => {
    store_creative.ads.select(ad, shiftKey);
  };

  const onReorder: AdListTableReorderCallback = ({ ads, flush }) => {
    ads.forEach((ad, newIndex) => {
      ad.setIndex(newIndex);
    });
    store_creative.ads.updateIndexes().finally(() => {
      flush();
    });
  };

  return (
    <Container>
      {isWorking && (
        <WorkMessage>{currentWorkMessage || DEFAULT_WORK_MESSAGE}</WorkMessage>
      )}
      <AdListToolbar disabled={isWorking} />
      <AdListTable
        ads={store_creative.ads}
        disabled={isWorking}
        onClick={onAdClick}
        onCheck={onAdCheck}
        onReorder={onReorder}
      />
    </Container>
  );
}

export default observer(AdList);
